import React, {PropTypes} from 'react';
import FormInput from './forminput.react';

export default class RadioInput extends FormInput {
  static propTypes = {
    action: PropTypes.func.isRequired,
    group: PropTypes.string.isRequired,
    field: PropTypes.string,
    title: PropTypes.string.isRequired,
    check: PropTypes.string,
    value: PropTypes.bool.isRequired,
  }

  onChange(event) {
    const {action, group, field} = this.props;
    const {target: {value}} = event;
    let itemValue = null;

    if ('string' === typeof field && field.length > 0) {
      itemValue = field;
    } else {
      itemValue = value;
    }

    action({target: {name: group, value: itemValue}});
  }

  render() {
    const {group, value, title} = this.props;
    let id = `radio_${group}_${title.replace(/[!\"#$%&'\(\)\*\+,\.\/:;<=>\?\@\[\\\]\^`\{\|\}~]/g, '')}`;
    id = id.replace(/ /g, '_');
    return (
      <div className="form-group radio-input">
        <div className="supplier bb-radio">
          <input
            id={id}
            checked={value}
            name={group}
            onChange={::this.onChange}
            type="radio"
            />
          <label htmlFor={id}>{title}</label>
        </div>
      </div>
    );
  }
}
